import {useCallback,useEffect,useRef} from 'react';

// Legacy APIs do not offer a common idempotent receipt. If a write fails,
// keep navigation locked rather than silently retrying a partially applied scan.
export function requireLegacySuccess(response){
 if(!response||response.success!==true)throw Error(response?.message||'Respuesta no confirmada');
 return response;
}
// Conservative browser-local fence, not server idempotency. A failed legacy
// scan must be reconciled before removing this marker; never auto-expire it.
export function createLegacyFence(storage){
 const key='mes.tracking.legacy.pending';let owned=null;
 return {
  pending:()=>storage.getItem(key)!==null,
  begin(context){
   if(storage.getItem(key)!==null)throw Error('LEGACY_REVIEW_REQUIRED');
   owned=JSON.stringify({order:String(context.order||''),path:context.path,time:new Date().toISOString()});
   storage.setItem(key,owned);if(storage.getItem(key)!==owned)throw Error('LEGACY_FENCE_NOT_SAVED');
  },
  clear(){if(storage.getItem(key)!==owned)throw Error('LEGACY_FENCE_CHANGED');storage.removeItem(key);if(storage.getItem(key)!==null)throw Error('LEGACY_FENCE_NOT_CLEARED');owned=null;}
 };
}
export default function useLegacyAction(onBusy=()=>{},context=()=>({})){
 const locked=useRef(false),notify=useRef(onBusy);notify.current=onBusy;
 const describe=useRef(context);describe.current=context;
 const fence=useRef(null);if(!fence.current)fence.current=createLegacyFence(window.localStorage);
 useEffect(()=>{
  try{if(!fence.current.pending())return;}catch(_){}
  locked.current=true;notify.current(true);
  window.alert('Existe un escaneo anterior sin confirmar en este navegador. No repitas el escaneo; solicita revisar la orden y su historial antes de continuar.');
 },[]);
 return useCallback((action,{write=false}={})=>async(...args)=>{
  args[0]?.preventDefault?.();
  if(locked.current)return;
  locked.current=true;notify.current(true);
  let uncertain=false;
  try{
   if(fence.current.pending())throw Error('LEGACY_REVIEW_REQUIRED');
   if(write)fence.current.begin({...describe.current(),path:window.location.pathname});
   const result=await action(...args);
   if(write)fence.current.clear();
   return result;
  }
  catch(error){
   uncertain=write;
   window.alert(write?'No se confirmó el registro completo. No repitas el escaneo; solicita revisar la orden antes de continuar.':`No se pudo consultar la orden: ${error.message}`);
  }finally{if(!uncertain){locked.current=false;notify.current(false);}}
 },[]);
}
